module.exports = __webpack_public_path__ + "media/images/views/home/banner/banner-sp-dfc585f4590f11808ce81b7ff0c81a1f.png";